import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { PhoneCollectionWrapper } from './PhoneCollectionWrapper';

async function LoadPhoneCollectionStep(): Promise<typeof PhoneCollectionWrapper> {
	return (
		await import(/* webpackChunkName: "pages/start-a-petition-steps-phone-collection" */ './PhoneCollectionWrapper')
	).PhoneCollectionWrapper;
}

export function PhoneCollectionLoader(): JSX.Element {
	const loadComponent = useCallback(LoadPhoneCollectionStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadPhoneCollectionStep = LoadPhoneCollectionStep;
